import script from "./VideoOutputField.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoOutputField.vue?vue&type=script&lang=ts&setup=true"

import "./VideoOutputField.vue?vue&type=style&index=0&id=025b36a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025b36a8"]])

export default __exports__